import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MibDTO } from '../model/configuration/snmp/mib-dto';


@Injectable({
  providedIn: 'root'
})
export class SnmpService extends BaseService {

  constructor(http: HttpClient, router: Router) {
    super(http, router)
  }

  uploadMibFile(form: FormData): Promise<MibDTO> {
    let request = this.postBinary<MibDTO>("snmp/mib", form);
    return this.apiCall<MibDTO>(request)
  }
}
